import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';

import { APP_ROUTES } from '@ps/core-config';

import { SurveyCreationCoreActions } from './survey-creation-core.actions';

@Injectable()
export class SurveyCreationTrackerEffects {
  private readonly _actions$ = inject(Actions);
  private readonly _router = inject(Router);

  // Reacts to the Tracker Configuration Drawer's confirm.
  public readonly navigateToCreateSurveyOnTrackerConfigSetup$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(SurveyCreationCoreActions.setupTrackerConfig),
        tap(() => this._router.navigate([APP_ROUTES.CREATE_SURVEY])),
      ),
    { dispatch: false },
  );
}
